"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const HideToolbarsButton = (0, react_1.forwardRef)((props, ref) => {
    const { onClick, disabled = false } = props;
    const analitycs = (0, analytics_1.useAnalytics)();
    const [isSelected, setIsSelected] = (0, react_1.useState)(false);
    const [tooltioIsOpen, setTooltipIsOpen] = (0, react_1.useState)(false);
    const { t } = (0, i18n_1.useTranslation)();
    const onHandleClick = () => {
        onClick();
        analitycs.log('hide_ui_button_pressed');
        setIsSelected(!isSelected);
        setTooltipIsOpen(false);
    };
    const onHover = () => {
        setTooltipIsOpen(true);
    };
    const onLeave = () => {
        setTooltipIsOpen(false);
    };
    return ((0, jsx_runtime_1.jsx)(TooltipHideButton, { ref: ref, width: 44, height: 44, isSelected: isSelected, onMouseEnter: onHover, onMouseLeave: onLeave, tooltip: {
            context: isSelected
                ? t(i18n_1.Strings.toolbar.showToolbarsTooltip)
                : t(i18n_1.Strings.toolbar.hideToolbarsTooltip),
            isOpen: tooltioIsOpen,
        }, onClick: onHandleClick, disabled: disabled }, `hide-tooltip-${tooltioIsOpen}`));
});
const TooltipHideButton = (0, ui_1.withTooltip)(ui_1.HideButton);
exports.default = HideToolbarsButton;
